import { useRSO } from "@/api/services/admin/rso";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { InnerBox } from "@/components/elements/InnerBox";
import { divider } from "@/theme/colors";
import { findLabelByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";
import { Grid } from "@mui/material";
import { styled } from "@mui/system";
import { BillingCountInfo, NO_PADDING_GRID_ITEM } from "@/components/commons/BillingCountInfo";

export const PartnerSummary = () => {
  const { data: matchResult } = useRSO();
  const { data: contractStatusOptions } = useEnum("ERSOContractStatus");

  const matchData = matchResult?.data;

  const contractStatus = findLabelByValue(contractStatusOptions, matchData?.contractStatus);

  return (
    <MatchInnerBox title="契約情報">
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <ItemInfo label="ステータス" value={contractStatus} />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="契約プラン" value={matchData?.contractPlan} />
        </Grid>
        <Grid item xs={3} sx={NO_PADDING_GRID_ITEM}>
          <BillingCountInfo label="最大課金対象数" count={matchData?.currentMonthBillingCount} date={matchData?.currentMonthBillingCountDate} />
        </Grid>
        <Grid item xs={3} sx={NO_PADDING_GRID_ITEM}>
          <BillingCountInfo label="前回課金対象数" count={matchData?.previousMonthBillingCount} date={matchData?.previousMonthBillingCountDate} />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="トライアル開始日" value={matchData?.trialStartDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="トライアル終了日" value={matchData?.trialEndDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="契約日" value={matchData?.contractStartDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <ItemInfo label="解約日" value={matchData?.contractEndDate} type="date" />
        </Grid>
      </Grid>
    </MatchInnerBox>
  );
};

const MatchInnerBox = styled(InnerBox)`
  border: 1px solid ${divider.high};
  padding: 8px;
`;
